import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Container, Typography, Card } from "@mui/material";
// import details from "../../mocks/details";
import { parseCurrency, parseDateTime } from "../../utils/tableFunctions";
import { getReconciledDetails } from "../../services/reconciliations";
import ReconDetailsHeader from "./ReconDetailsHeader";
import { Box } from "@mui/system";
import CircularLoader from "../../components/circularLoader";

const ReconciledDetails = () => {
  const [details, setDetails] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [refs, setRefs] = useState([]);

  const { id } = useParams();
  useEffect(() => {
    if (!loaded) {
      getReconciledDetails(id, setDetails, setRefs, setLoaded);
    }
  }, [id, loaded]);

  const renderReconciledCard = (detail) => {
    return (
      <>
        <Card sx={{ p: 3 }}>
          <Grid container direction={{ xs: "column", sm: "row" }}>
            <Grid item xs={6} md={6}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Transaction ID</Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={7}
                  sx={{
                    overflowWrap: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {detail.transaction.id}
                </Grid>
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Terminal ID</Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  {detail.terminal && detail.terminal.terminal_id}
                </Grid>
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Transaction Time</Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  {parseDateTime(detail.transaction_datetime)}
                </Grid>

                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">
                    Acquirer Request Amount
                  </Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  {detail.acquirer_request_currency &&
                    `${detail.acquirer_request_currency} ${parseCurrency(
                      detail.acquirer_request_amount
                    )}`}
                </Grid>

                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Acquirer Status</Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  {detail.acquirer_status}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} md={6}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Card Number</Typography>
                </Grid>
                <Grid item xs={4} md={7}>
                  {detail.payer_details
                    ? detail.payer_details.payer_card_masked
                    : ""}
                </Grid>
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">
                    Reference Number
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={7}
                  sx={{
                    overflowWrap: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {detail.reference_number}
                </Grid>

                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">
                    Request Amount
                  </Typography>
                </Grid>
                <Grid item xs={4} md={7}>
                  {detail.transaction_currency &&
                    `${detail.transaction_currency} ${parseCurrency(
                      detail.transaction_amount
                    )}`}
                </Grid>

                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Status</Typography>
                </Grid>
                <Grid item xs={4} md={7}>
                  {detail.transaction_state.transaction_state}
                </Grid>
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">
                    Transaction Type
                  </Typography>
                </Grid>
                <Grid item xs={4} md={7}>
                  {detail.transaction_type.transaction_type}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
        <Box sx={{ height: 30 }} />
      </>
    );
  };

  return (
    <>
      <Container>
        {loaded ? (
          <>
            <ReconDetailsHeader
              loaded={loaded}
              title="Reconciled Reconciliation Details"
              details={details}
            />
            {renderReconciledCard(details)}

            {loaded &&
              refs.length > 1 &&
              refs.slice(1).map((trans) => {
                return renderReconciledCard(trans);
              })}
          </>
        ) : (
          <CircularLoader />
        )}
      </Container>
      {/* </Dialog> */}
    </>
  );
};

export default ReconciledDetails;
